import React, {useState} from "react";
import PDF from "../../img/PDF.png";
import HTML from "../../img/HTML.png";
import EditBook from "../../img/EditBook.png";
import Star from "../../img/Star.png";
import Filter from "../../img/Filter.png";
import AddToBookList from "../../img/AddToBookList.png";
import StartReading from "../../img/StartReading.png";
import {Link} from "react-router-dom";
import axios from "axios";
import {connect} from "react-redux";
import {fetch_books, fetch_booklists, addToBookList, removeBookList} from "./action/books.js";

class DashboardMyBooksPage extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
         "ov": false,
         "books": props.books
      };
    }
    ov = () => {
        this.setState({"ov": false});
    };
    ovv = () => {
        this.setState({"ov": true});
    };
    sortLast = e => {
        const books = this.state.books;
        books.reverse()
        this.setState({books: books})
    };
    sortNone = e=> {
        // const oldBooks = this.state.oldBooks;
        // const books = this.state.books;
        // if(oldBooks.reverse() === books){
        //     console.log(books)
        //     this.setState({books: books})
        // }
    };
    RecView = e=>{
        const books = this.state.books;
        books.sort(function(a, b){
            return new Date(b.recentlyViewed) - new Date(a.recentlyViewed)
        })
        this.setState({books: books})
    };
    dateCreatedOn = e=>{
        const books = this.state.oldBooks;
        for(var i = 0; i< books.length; i++){
            var dateCreatedOn = new Date(books[i].dateCreatedOn);
            var dateCreatedOn2 = new Date(e);
            var val1 = dateCreatedOn.getDate()+dateCreatedOn.getMonth()+dateCreatedOn.getYear();
            var val2 = dateCreatedOn2.getDate()+dateCreatedOn2.getMonth()+dateCreatedOn2.getYear();
            if(val1 === val2){
                books.sort(function(val1, val2){
                    return val1 === val2
                })
                this.setState({books: books});
            }else{
                this.setState({books: []})
            }
        }
    };
    bookType = e=>{
        const books = this.state.oldBooks;
        const oldBooks = this.state.oldBooks;
        for(var i = 0; i< books.length; i++){
    
            if(e !== "None"){
                var val1 = books[i].book_type;
                var val2 = e;
                if(val1 === val2){
                books.sort(function(val1, val2){
                    console.log(val2)
                    return val1 === val2
                })
                console.log(books)
                this.setState({books: books});}else{
                    this.setState({books: []})
                }
            }else{
                this.setState({books: oldBooks})
            }
        }
    };
    addToBookList = e=>{
        this.setState({loading: true})
        this.props.addToBookList(e).then(msg => {
            window.location.reload();
        })
    };
    removeBookList = e=>{
        this.setState({loading: true})
        const inTheBookList = this.props.books[e.bookId].inTheBookList;
        console.log(inTheBookList);
        var index = "🤶🤶";
        for(var i = 0; i<inTheBookList.length; i++){
            if(this.props.books[e.bookId].inTheBookList[i] === e.bookListId){
                index = i;
            }
        }
        inTheBookList.splice(index)
        console.log(inTheBookList)
        this.props.removeBookList({bookId: e.bookId, bookListId: e.bookListId, total_noof_books: e.total_noof_books, toSet: inTheBookList}).then(msg => {
            window.location.reload();
        })
    };
    clear = e => {
        alert("Clearing")
        this.setState({books:this.props.books});
    };
    apply=e=>{
        console.log(e)

    };
    render(){
        const {booklists} = this.props;
        const {addToBookList, removeBookList, addBooklist} = this;
        return(
            <div className="book_page">
                <div className="books_container">
                    {this.props.searchedContents ? this.props.searchedContents!==[] && this.props.length!==0 && this.props.length === this.props.searchedContents.length &&
                        this.props.searchedContents.map(function(item){
                        return <Book 
                            key={item.bookId}
                            bookId = {item.bookId}
                            addToBookList={addToBookList}
                            title={item.book_title}
                            booklists={booklists}
                            removeBookList={removeBookList}
                            description={item.book_description} 
                            chapters={item.total_chapters}
                            pages={item.total_pages}
                            inTheBookList={item.inTheBookList}
                            type={item.book_type}
                            imageSrc={item.book_cover}
                        />
                    }):this.state.books !== [] ?
                    this.state.books.map(function(item){
                        return <Book 
                            key={item.bookId}
                            bookId = {item.bookId}
                            title={item.book_title}
                            description={item.book_description} 
                            chapters={item.total_chapters}
                            addToBookList={addToBookList}
                            removeBookList={removeBookList}
                            pages={item.total_pages}
                            type={item.book_type}
                            booklists={booklists}
                            inTheBookList={item.inTheBookList}
                            imageSrc={item.book_cover}
                        />
                    }):<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    }

                    {this.state.loading && <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>}
                </div>
            </div>
        );
    }
};

const Book = (props) => {
    const [dropdown, changeDropdown] = useState(false);
    return(
        <div className="book" style={dropdown ?{ "zIndex": "2"}: {"zIndex": "1"}}>
        <Link to={"/main/books/"+props.bookId} className="pagalHain">
            <div>
            {props.imageSrc&&
                <img src={"/root/user/"+props.imageSrc} alt="Book_COver" className="book_cover"/>
            }
            </div>
            <div className="rightSection">
                <h2 className="book_title p">{props.title}</h2>
                <div className="total_section">
                    <h6>Total Chapters: <b>{props.chapters}</b></h6>
                    <h6>Total Pages: <b>{props.pages}</b></h6>
                </div>
                <p className="description">{ props.description.substring(0, 95)} {props.description.length > 94 && (<span className="text-danger"><b><u>Read More...</u></b></span>)}</p>
            </div>
            <div className="type">
                {(props.type === "PDF") ? <img src={PDF} alt="PDF" className="PDF"/>:<img src={HTML} alt="HTML" className="HTML"/>}
            </div>
        </Link>
            <div className="footerleft">
                <Link to={"/main/editBook/"+props.type+"/"+props.bookId}><img src={EditBook} alt="Edit Book" className="editBook" /></Link>
                {(props.catergory === "faviorate") ? (<div className="faviorate"></div>):
                (<img src={Star} alt="Not Faviorate"className="nfaviorate"/>)}
                <img src={AddToBookList} alt="Add To Book List" className="atbl" onClick={() => {if(dropdown === false){changeDropdown(true)}else{changeDropdown(false)}}}/>
            </div>
            {dropdown && (
            <div className="bookListList">
                {props.booklists.length !== 0 ? <h1 className="book_title add">Click To Add</h1>:<h1 className="book_title add">No booklist in your book room, Please <span onClick={props.addBooklist}><Link to="/main/createBooklist">create one</Link></span></h1>}

                {props.booklists && props.booklists !== [] && props.booklists.map(function(item){
                    return <FormOfBookList key={item.bookListId} item={item} addToBookList={(e) => {props.addToBookList({bookListId: e, total_noof_books: item.total_noof_books+1,bookId: props.bookId})}} removeBookList={(e) => {props.removeBookList({bookListId: e, total_noof_books: item.total_noof_books-1,bookId: props.bookId})}} inThisBookList={props.inTheBookList}/>
                })}
            </div>)}

            <Link to={"/main/books/readBook"+props.type+"/"+props.bookId} className="footerright">
                <img src={StartReading} alt="Start Reading" className="sr" />
            </Link>
            </div>
    )
};

class FormOfBookList extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        checked: false
      };
    }
    componentDidMount(){
        for(var i = 0; i<this.props.inThisBookList.length; i++){
            if(parseInt(this.props.inThisBookList[i]) === parseInt(this.props.item.bookListId)){
                this.setState({checked: true})
            }
          }
    }
    onChange = e=> {
        if(this.state.checked === true){
            this.setState({checked: false})
            this.props.removeBookList(this.props.item.bookListId);
        }else{
            this.setState({checked: true})
            console.log(this.props.item.bookListId)
            this.props.addToBookList(this.props.item.bookListId);
        }
    }
    render(){
        return(
            <form className="bookListItem">
                <input type="checkbox" id={this.props.item.bookListId} checked={this.state.checked} bookid={this.props.item.bookListId} onChange={this.onChange} name={this.props.item.bookListId}/>
                <label htmlFor={this.props.item.bookListId} className="ml-2">{this.props.item.booklist_title}</label>
            </form>
        )
    }
}

// const booksArray = [
//                 {"id": "1","title": "Marigold", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "40", 
//                 "pages": "110", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4merdutAU-qnW7qtMPSd1DuBSPElKc0FFWiCThL37NYTPXjFKrYov2N0449feeMGA09BYufO9NlBkulweJm1APpKaY1Zn9-GJr95CArH-8iXmPARR6RzSV6oMqG6wEZw2w2Au2rHh7YmuU8G3Bjvv8paxXb2rxUfhXMHG8gANKuTO6g0Q1hTx4YpFuKOepLsEw?width=1500&height=2010&cropmode=none"},
               
//                 {"id": "2","title": "The Art Of Software Testing", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "151", 
//                 "pages": "509", 
//                 "type": "HTML", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mwn52L-eanuKML0gLxGrVu60cTFm2zZv-LFJRLJ1Cc5i6L-6OF7IUvXAauqB-KWvanpWJly4pmRgY10RyAuOsbSIiXR7fHLYtG67PJcCXyIG4n_aymfWAzj5RBKkEmUfGkcUVgC1CRTxkt7Xz8RR0u4MRPI90zoTYHX7Cp6pyfKSGCJHUfFHTRYtKUPyZ2NQZ?width=333&height=499&cropmode=none"},
                
//                 {"id": "3","title": "Operating System Concepts", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "243", 
//                 "pages": "909", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mhIa7vf_8nYgOQMO9MVac-147dyc7O4c7aElCYxiHPRAfWu_MwuyUpyvVmwD1siXPIL5bnR5KsBb9JxcCYCqxNrQyil61bxgACJhQdDY2qzinoHsusPUIlw6nIsCL6Iur3HeKia6EIo-G0jIPg_wk4K36uY7gtq15_2bzuXwiLBWjZfRMre4rJz8DhB4Sj-V8?width=342&height=500&cropmode=none"},
//                 {"id": "4","title": "C++", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "151", 
//                 "pages": "509", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mKn7RQioz8UkBVBbdpEvmutdaWGLQ_DiDBJZX4ir64fRKrjZixAJdivzrzsbYC65FZQm5pAFeOWcmMWzMbPL5HdNMvlvQLfqhykGqjMVSQwmxNr8UXYwEmI2Z16DrPCBdQogqUc3mvdKY07vsuG5JGS1sTCbrzu7Mwm-qzDNm3BJoGypPbb6yQjl2bt0TgThM?width=384&height=499&cropmode=none"}];


function mapStateToProps(state){
    return {
        isAuthenticated: !!state.user.name, 
        books: state.AllBooks.books, 
        booklists: state.AllBooklists.bookLists, 
        searchedContents: state.SearchBook.books,
        length: state.SearchBook.length
    }
}

export default connect(mapStateToProps, {fetch_books, addToBookList, removeBookList, fetch_booklists})(DashboardMyBooksPage);